import React, { useState } from "react";
//shared components
import DateDropDown from "../../../SharedComponents/DateDropDown/DateDropDown";


const ReportingSelecterBar = (props) => {

    const dateDropDownValues = ['Prev 7 Days', 'Prev 14 Days', 'Prev 28 Days', 'This Month', 'Last Month'];

    return (
        <div className="reporting-selecter-bar">
            <div className="result-limit-container">
                <label >Result Limit: </label>
                <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">70</option>
                    <option value="100">100</option>
                </select>
            </div>
            <div className="date-dropdown-container">
                <DateDropDown setValue={props.setTimeRange} value={props.timeRange} dateDropDownValues={dateDropDownValues} />
            </div>
            <button className="button">Apply</button>
        </div>
    )
};
export default ReportingSelecterBar;